<div class="grid">
  <div class="col-12 md:col-12 lg:col-12">
    <h1 class="titulo-pagina">{{ 'VINCULACIONTERCERO.LBL_SUBMENU' | translate}}</h1>
  </div>
</div>
<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">

  <div class="grid">
    <div class="col-12 md:col-12 lg:col-12 text-center">
      <h2>{{menuVinculacion.nombreMenuVisita}}</h2>
    </div>
  </div>

  <div class="grid">
    <div class="col-12 md:col-4 lg:col-4 md:col-offset-4 lg:col-offset-4">
      <p-tree id="treeBien" [(value)]="treeProperties" selectionMode="single" [(selection)]="nodeSelected" [loading]="loadingTree">
        <ng-template let-item pTemplate="default">
          <span>{{ item.label }}</span>
        </ng-template>
      </p-tree>
    </div>
  </div>

</div>
<div class="grid form-footer-buttons">
  <div class="form-group col-12">
    <div>
      <button icon="fa fa-arrow-left" label="{{'BTN_REGRESAR' | translate }}"
              type="button" (click)="regresar()"
              pButton></button>
    </div>
  </div>
</div>


<p-confirmDialog #cd>
  <ng-template pTemplate="footer">
    <button type="button" pButton icon="fa fa-close" label="{{ 'LBL_NO' | translate }}" (click)="cd.reject()"></button>
    <button type="button" pButton icon="fa fa-check" label="{{ 'LBL_SI' | translate }}" (click)="cd.accept()"></button>
  </ng-template>
</p-confirmDialog>
